import { CONNECT_VISIBLE_AVATARS } from '@epicuro-next/platform/configuration';
import { createSelector } from '@ngrx/store';

import {
  adapter,
  connectContactsFeatureKey,
} from '../reducers/connect-contacts.reducer';
import { selectConnectState } from '../store';

export const selectConnectContactsState = createSelector(
  selectConnectState,
  (state) => state[connectContactsFeatureKey],
);

const { selectAll, selectEntities } = adapter.getSelectors(
  selectConnectContactsState,
);

/**
 * Selector to get the contacts
 */
export const selectAllContacts = selectAll;

/**
 * Returns the first three users contacts
 */
export const selectFirstThreeUserContactsState = createSelector(
  selectAllContacts,
  (contacts) => contacts.slice(0, CONNECT_VISIBLE_AVATARS),
);

/**
 * Returns user current contact
 */
export const selectUserCurrentContactState = createSelector(
  selectConnectContactsState,
  selectEntities,
  (state, contacts) => {
    if (!state.selectedContactId) {
      return null;
    }
    return contacts[state.selectedContactId];
  },
);

/**
 * Returns a single contact
 */
export const selectContact = (userId: string) =>
  createSelector(selectEntities, (contacts) => contacts[userId]);

/**
 * Returns user contacts
 */
export const selectUserContactsState = createSelector(
  selectAllContacts,
  (contacts) => contacts,
);
